import NAVBAR from 'components/navbar';

function DescontoParceiro(){
    return <>
    <NAVBAR />
    <h1>Desconto Parceiro</h1>
    </>
}
export default DescontoParceiro;